import { render } from "./BreadCrumb.vue?vue&type=template&id=6c046d20"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=6c046d20&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__